(function() {
  if (window.__legrammeProductItemSectionSwiperLoaded) {
    return;
  }
  window.__legrammeProductItemSectionSwiperLoaded = true;

  function initSwipers(root) {
    if (typeof Swiper === 'undefined') {
      return;
    }

    var scope = root || document;
    var swipers = scope.querySelectorAll('[data-element="product-item-section-swiper"]');

    swipers.forEach(function(swiperElement) {
      if (swiperElement.swiper) {
        swiperElement.swiper.update();
        return;
      }

      var nextEl = swiperElement.querySelector('.swiper-button-next');
      var prevEl = swiperElement.querySelector('.swiper-button-prev');
      var productItemElement = swiperElement.closest('.product-item');
      var scrollbarEl = null;
      var paginationEl = null;

      if (productItemElement) {
        scrollbarEl = productItemElement.querySelector('.product-item__images-scrollbar.swiper-scrollbar');
        paginationEl = productItemElement.querySelector('.product-item__images-pagination.swiper-pagination');
      }

      if (!scrollbarEl) {
        scrollbarEl = swiperElement.querySelector('.swiper-scrollbar');
      }

      if (!paginationEl) {
        paginationEl = swiperElement.querySelector('.swiper-pagination');
      }

      const swiperOptions = {
        slidesPerView: 1,
        speed: 500,
        loop: false,
        watchOverflow: true,
        nested: true,
        preventClicks: true,
        preventClicksPropagation: true
      };

      [nextEl, prevEl].forEach(function(controlElement) {
        if (!controlElement) {
          return;
        }

        controlElement.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
        });

        controlElement.addEventListener('pointerdown', function(event) {
          event.stopPropagation();
        });
      });

      if (nextEl && prevEl) {
        swiperOptions.navigation = {
          nextEl: nextEl,
          prevEl: prevEl
        };
      }

      if (scrollbarEl) {
        scrollbarEl.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
        });

        scrollbarEl.addEventListener('pointerdown', function(event) {
          event.stopPropagation();
        });

        swiperOptions.scrollbar = {
          el: scrollbarEl,
          draggable: true
        };
      }

      if (paginationEl) {
        swiperOptions.pagination = {
          el: paginationEl,
          type: 'progressbar',
        };
      }

      new Swiper(swiperElement, swiperOptions);
    });
  }

  function initAndRefreshAll(root) {
    var scope = root || document;
    initSwipers(scope);
    scope.querySelectorAll('[data-element="product-item-section-swiper"]').forEach(function(swiperElement) {
      if (swiperElement.swiper) {
        swiperElement.swiper.update();
      }
    });
  }

  window.initProductItemSectionSwipers = initAndRefreshAll;

  document.addEventListener('DOMContentLoaded', function() {
    initAndRefreshAll(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initSwipers(event.target);
  });

  document.addEventListener('click', function(event) {
    var tabTrigger = event.target.closest('[data-action="change-tab"]');
    if (!tabTrigger) {
      return;
    }

    setTimeout(function() {
      initAndRefreshAll(document);
    }, 120);
  });

  var resizeTimer = null;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      initAndRefreshAll(document);
    }, 120);
  });
})();
